/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseUnreadCountDTO interface.
 */
export function instanceOfWarehouseCaseUnreadCountDTO(value) {
    return true;
}
export function WarehouseCaseUnreadCountDTOFromJSON(json) {
    return WarehouseCaseUnreadCountDTOFromJSONTyped(json, false);
}
export function WarehouseCaseUnreadCountDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'] == null ? undefined : json['count'],
    };
}
export function WarehouseCaseUnreadCountDTOToJSON(json) {
    return WarehouseCaseUnreadCountDTOToJSONTyped(json, false);
}
export function WarehouseCaseUnreadCountDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
    };
}
